var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgBlueCurveWire = function SvgBlueCurveWire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 631,
    height: 551,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 17.181c38.026 167.833 167.698 506 382.18 516 268.102 12.5 283.34-285.5 56.009-264.5",
    stroke: "#4B47FC",
    strokeWidth: 33,
    strokeLinecap: "round"
  })));
};
export default SvgBlueCurveWire;